import { render, staticRenderFns } from "./housekeepingServUserManage.vue?vue&type=template&id=5d2219c2&scoped=true"
import script from "./housekeepingServUserManage.vue?vue&type=script&lang=js"
export * from "./housekeepingServUserManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServUserManage.vue?vue&type=style&index=0&id=5d2219c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2219c2",
  null
  
)

export default component.exports